// =============================== 
// PRODUTOS DO JUMBO+CALCULOS
// ===============================

Produto = {
    _root: $('.m-produtos-cart'),
    addItem: function (id) {
        var field = $('input[name="quantidade[' + id + ']"]', Produto._root);
        var max = Number(field.attr("data-max"));
        var now = Number(field.val());

        var checkbox = field.parent().parent().parent().parent().prev();

        if (!checkbox.prop("checked")) checkbox.click();

        if (max == now) {
            field.animate({ 'background-color': '#cb4f44' }, 100, function () {
                field.animate({ 'background-color': '#fff' })
            });
            return false;
        } else {
            field.val(now + 1);
        }
        field.trigger('change');
        Produto.calcSubtotal(id);
    },
    removeItem: function (id) {
        var field = $('input[name="quantidade[' + id + ']"]', Produto._root);
        var now = Number(field.val());
        if (now !== 0) {
            field.val(now - 1);
        } else {
            return false;
        }
        field.trigger('change');
        Produto.calcSubtotal(id);
    },
    calcSubtotal: function (id) {
        var qtd = Number($('input[name="quantidade[' + id + ']"]', Produto._root).val());
        var uniPrice = Number($('select[name="marca[' + id + ']"] option:selected', Produto._root).attr("data-price"));
        var uniWeight = Number($('select[name="marca[' + id + ']"] option:selected', Produto._root).attr("data-weight"));
        var calcPrice = qtd * uniPrice;
        var calcWeight = qtd * uniWeight;

        //calcPrice += $('#sendmail').prop("checked") ?  Number($('#sendmail').attr("data-price")) : 0;

        console.debug("Sub Total: ", calcPrice);

        $('input[name="subtotalPreco[' + id + ']"]', Produto._root).val(calcPrice);
        $('input[name="subtotalPeso[' + id + ']"]', Produto._root).val(calcWeight);
        $('input[name="preco[' + id + ']"]', Produto._root).val(uniPrice);

        var result = "+ R$ " + Moeda.formatar(calcPrice);
        if (!calcPrice) { result = ""; }


        $('.item[data-product-id=' + id + '] .show-price', Produto._root).html(result);

        $(".m-produtos-cart .category").each(function (foo, bar) {
            var r = 0;
            $(".item input[name^='subtotalPreco']", bar).each(function (k, v) {
                r = r + Number($(v).val());
            });

            $("input[name^='subtotalCategoria']", bar).val(r);
            $(".price-subtotal", bar).html("+ R$ " + Moeda.formatar(r));
        });

        Produto.calcTotal(2);
    },
    mudaMarca: function (id) {
        var price = Number($('select[name="marca[' + id + ']"] option:selected', Produto._root).attr("data-price"));

        $('.item[data-product-id=' + id + '] .marca .price-unit', Produto._root).html("R$ " + Moeda.formatar(price));
        $('input[name="preco[' + id + ']"]', Produto._root).val(price);

        Produto.calcSubtotal(id);
    },
    calcTotal: function (num) {
        var result = 0;
        $(".m-produtos-cart .category input[name^='subtotalCategoria']").each(function (foo, bar) {
            result = result + Number($(bar).val());
        });

        if ($('.m-produtos-cart .send-photos').length > 0) {
            var qtd = Number($('.m-produtos-cart .send-photos input[name=qtdFoto]').val());
            var price = Number($('.m-produtos-cart .send-photos input[name=priceFoto]').val());
            var FotoResult = qtd * price;

            $(".m-produtos-cart .send-photos .price-subtotal").html("+ R$ " + Moeda.formatar(FotoResult));

            result = result + FotoResult;
        }

        if ($('.m-produtos-cart .send-mail').length > 0) {

            var subtotalCarta = Number($('#sendmail').attr("data-price"));
            subtotalCarta = $('#sendmail').prop("checked") ? subtotalCarta : 0;

            result = result + subtotalCarta;
        }

        if ($(".produtos-index").length) {

            if (result)
                $('button[type="submit"]').css({ opacity: 1 });
            else
                $('button[type="submit"]').css({ opacity: 0.5 });
        }

        $('.m-main-header .cart .price, .m-produtos-cart .finish-form .total-cart .price-total, .btn .price-total-btn').html("R$ " + Moeda.formatar(result));

        Produto.calcPeso();
    },
    calcPeso: function () {
        var result = 0;
        var limit = Number($("input[name='limitepeso']", Produto._root).val());
        var pesocaixa = Number($("input[name='pesocaixa']", Produto._root).val());
        var disponivel;

        $("input[name^='quantidade']", Produto._root).each(function (key, element) {
            if ($(element).val() > 0) {
                var t = $(this).closest('[data-product-id]');
                var p = Number($('.marca select option:selected', t).attr("data-weight"));
                var q = Number($(this).val());
                var pesoItem = q * p;

                result = result + pesoItem;
            }
        });

        if (result > 0)
            result = result + pesocaixa

        disponivel = limit - (result);

        if (disponivel < 0) {
            $('.peso-jumbo').addClass('is-err');
        } else {
            $('.peso-jumbo').removeClass('is-err');
        }

        $('.maxWeight .show-weight').html(disponivel.toFixed(1) + "<span class=\"units\">kg</span>");

        $("input[name=pesojumbo]").val(result.toFixed(3));
    },
    validar: function () {
        var erros = 0;
        var produtos = 0;
        var limitePeso = Number($("input[name='limitepeso']", Produto._root).val());
        var pesoJumbo = Number($("input[name='pesojumbo']", Produto._root).val());
        var peso = limitePeso - pesoJumbo

        if (peso < 0) {
            alert("Seu Jumbo ultrapassou o limite de peso, retire alguns produtos e tente novamente.")
            return false;
        }

        $("input[name^='quantidade']", Produto._root).each(function (key, element) {
            if ($(element).val() > 0) {
                produtos++;
            }
        });

        // $(".m-produtos-cart .send-photos .content .wrap-photo input").each(function(key, val) {
        //     if (!$(this).val()) {
        //         EnviarFotos.removerFoto($(this).parent());
        //     }
        // });

        if (produtos == 0) {
            alert("Seu Jumbo está vazio.");
            return false;
        }

        if (erros > 0) {
            return false;
        }
    }
}

// =============================== 
// FORMATAÇÃO DE MOEDA
// ===============================
var Moeda = {
    desformatar: function (num) {
        num = num.replace(".", "");
        num = num.replace(",", ".");
        return parseFloat(num);
    },
    formatar: function (num) {
        x = 0;
        if (num < 0) {
            num = Math.abs(num);
            x = 1;
        }
        if (isNaN(num)) num = "0";
        cents = Math.floor((num * 100 + 0.5) % 100);
        num = Math.floor((num * 100 + 0.5) / 100).toString();
        if (cents < 10) cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
            num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
        ret = num + ',' + cents;
        if (x == 1) ret = ' ? ' + ret;
        return ret;
    },

    arredondar: function (num) {
        return Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2);
    }
}

// =============================== 
// ENVIO DE FOTOS
// ===============================
EnviarFotos = {
    addFoto: function () {
        $('.m-produtos-cart .send-photos .content .fotos-list input').each(function (key, obj) {
            if (!$(this).val()) {
                //EnviarFotos.removerFoto($(this).parent());
            }
        });

        var max = Number($('.m-produtos-cart .send-photos').attr("data-max"));
        var qtd = Number($('.m-produtos-cart .send-photos').attr("data-quantify")) + 1;

        if (qtd <= max) {
            $('.m-produtos-cart .send-photos').attr("data-quantify", qtd);
            $('.m-produtos-cart .send-photos input[name=qtdFoto]').val(qtd);
            $('.m-produtos-cart .send-photos .content .wrap-photo.btn-add-photo .show-qtd').text(qtd);
            if (qtd == max) {
                $('.m-produtos-cart .send-photos .content .wrap-photo.btn-add-photo').addClass('is-inactive');
            }

            var id = Math.floor((Math.random() * 10000) + 1);
            var tpl =
                "<div class=\"wrap-photo\" data-id=\"" + id + "\" data-id-pedido=\"\">" + "<div class=\"image-wrap\">" + "<figure>" + "<img src=\"./assets/img/preloader.gif\">" + "</figure>" + "</div>" + "<span class=\"btn-remove\">" + "<i class=\"fa fa-close\"></i>" + "</span>" + "<input type=\"file\" id=\"imagem-" + id + "\" name=\"foto[]\" accept=\"image/*\">" + "</div>";

            $('.m-produtos-cart .send-photos .content .fotos-list').append(tpl);
            $('.m-produtos-cart .send-photos .content .fotos-list .wrap-photo[data-id="' + id + '"] input').click();
        }

        Produto.calcTotal(3);

    },
    removerFoto: function (element) {

        var id_pedido = element.data('id-pedido');
        var id_foto = element.data('id');

        $.ajax({
            url: 'pedido/remover_imagem',
            type: 'POST',
            dataType: 'json',
            data: {
                id_pedido: id_pedido,
                id_foto: id_foto
            },
        })
            .done(function (dt) {
                if (dt.err == 1) {
                    alert(dt.msg)
                    return false;
                }
            });

        element.remove();
        var max = Number($('.m-produtos-cart .send-photos').attr("data-max"));
        var qtd = Number($('.m-produtos-cart .send-photos').attr("data-quantify")) - 1;

        $('.m-produtos-cart .send-photos').attr("data-quantify", qtd);
        $('.m-produtos-cart .send-photos .content .wrap-photo.btn-add-photo .show-qtd').text(qtd);
        $('.m-produtos-cart .send-photos input[name=qtdFoto]').val(qtd);
        if (qtd < max) {
            $('.m-produtos-cart .send-photos .content .wrap-photo.btn-add-photo').removeClass('is-inactive');
        }
        Produto.calcTotal(4);
    },
    update: function (id) {
        var obj = $('.m-produtos-cart .send-photos .content .fotos-list .wrap-photo[data-id="' + id + '"]');
        var imgUrl = $('#imagem-' + id)[0].files[0];

        if (imgUrl) {
            var reader = new FileReader();
            reader.readAsDataURL(imgUrl);

            reader.onload = function (e) {
                $('.image-wrap img', obj).attr("src", e.target.result);
            }
        }

        // reader.readAsDataURL( $('#imagem-'+id).files );

    }
}

// =============================== 
// ADD OU REMOVE PRODUTOS DO JUMBO
// ===============================
$('.m-produtos-cart .controlador .btn').click(function (event) {
    event.preventDefault();
    var id = $(this).closest('[data-product-id]').attr("data-product-id");
    if ($(this).hasClass('btn-more')) {
        Produto.addItem(id);
    } else if ($(this).hasClass('btn-less')) {
        Produto.removeItem(id);
    }
});

// =============================== 
// CHECA MARCA E PREÇO
// ===============================
$('.m-produtos-cart .category .category-content .item .marca select').change(function () {
    var id = $(this).closest('[data-product-id]').attr("data-product-id");
    Produto.mudaMarca(id);
});

// =============================== 
// ACORDEON PARA MOBILE
// ===============================
$('.m-produtos-cart .category .category-header .expand, .m-produtos-cart .send-mail .header .expand').click(function (event) {
    event.preventDefault();
    $(this).parent().parent().toggleClass('is-active');
    $('.fa', this).toggleClass('fa-chevron-down fa-chevron-up');
});

$('.m-produtos-cart .category .category-content .item > input').on('init change', function () {
    var input = $(this);
    var $this = input.siblings('fieldset').find('input[name*="quantidade"]');
    var min = input.closest('[data-min]').data('min');

    // $this.val(input.is(':checked') ? Math.max(min || 0,1) : 0).trigger('change');
    $this.val(input.is(':checked') ? Math.max(Math.min($this.val() || min), 1) : 0).trigger('change');
}).trigger('init');

$('.page-content.produtos .header-page .toggle-address').on('click', function (e) {
    e.preventDefault();
    var button = $(this);
    button.closest('.header-page').toggleClass('address-open');
});
$('.page-content.produtos .header-page .address button').on('click', function (e) {
    e.preventDefault();

    $('html,body').animate({ scrollTop: $('#scroll-target').offset().top - 50 }, 500);
});

// =============================== 
// VALIDA FORMULARIO
// ===============================
$('.m-produtos-cart form').submit(function (event) {
    return Produto.validar();
});

// =============================== 
// PESO FIXO
// ===============================
// $(document).scroll(function() {
//     var s = $(window).scrollTop();
//     if (s > 140) {
//         $('.peso-jumbo').addClass('is-active');
//     } else {
//         $('.peso-jumbo').removeClass('is-active');
//     }
// });

// =============================== 
// REMOVE FOTO
// ===============================
$('body').delegate('.m-produtos-cart .send-photos .btn-remove', 'click', function (event) {
    EnviarFotos.removerFoto($(this).parent());
});

// =============================== 
// ADD FOTO
// ===============================
$('body').delegate('.m-produtos-cart .send-photos .content .wrap-photo.btn-add-photo', 'click', function (event) {
    EnviarFotos.addFoto();
});

// =============================== 
// ATUALIZA PREVIEW DO ARQUIVO DE IMAGEM
// ===============================
$('body').delegate('.m-produtos-cart .send-photos .content .wrap-photo input', 'change', function (event) {
    EnviarFotos.update($(this).parent().attr("data-id"));
});

// =============================== 
// CONTROLADOR ENVIO CARTA
// ===============================
$('.m-produtos-cart .send-mail input[name=enviarCarta]').change(function (event) {
    var p = $(this).parent().parent();
    var price = Number($(this).attr("data-price"));
    var result = 0;

    if ($(this).is(":checked")) {
        $('textarea', p).removeAttr("disabled");
        result = 1 * price;
    } else {
        $('textarea', p).attr("disabled", "disabled");
        result = 0;
    }

    $('.m-produtos-cart .send-mail .price-subtotal').html("+ R$ " + Moeda.formatar(result));
    $('.m-produtos-cart .send-mail input[name=subtotalCarta]').val(result);
    Produto.calcTotal(5);
});

// =============================== 
// VERIFICA VALORES DIGITADOS NO CAMPO DE QUANTIDADE
// ===============================
$("input[name^='quantidade']").on('keyup change', function (event) {
    var field = $(this);
    var input = Number(field.val());
    var max = Number(field.attr("data-max"));
    var id = field.closest('[data-product-id]').attr("data-product-id");
    if (input > max) {
        field.val(max);
        field.animate({ 'background-color': '#cb4f44' }, 100, function () {
            field.animate({ 'background-color': '#fff' }, 400);
        });
    } else if (input < 0) {
        field.val(0);
    }
    if (input == 0) {
        field.closest('fieldset').siblings('input').prop('checked', false)
    }
    Produto.calcSubtotal(id);
});

$("input[name^='quantidade']").trigger("change");

// =============================== 
// ESCONDE E MOSTRA MENU FIXO AO 
// ===============================
$('.m-produtos-cart .send-mail .content .campo textarea').focusin(function (event) {
    $('.m-produtos-cart .peso-jumbo').removeClass('is-active');
}).focusout(function () {
    $('.m-produtos-cart .peso-jumbo').addClass('is-active');
});

$(".btn-save").click(function () {
    $("input[name=acao]").val('salvar');
});

$(".btn-continue").click(function () {
    $("input[name=acao]").val('continuar');
});

Produto.calcTotal(1);


$('.page-content.produtos .valuations').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    responsiveClass: true,
    responsive: {
        768: {
            items: 2,
        },
        1000: {
            items: 3,
        }
    }
});

/*
    Expande as categorias ao entrar na página
*/
$(".expand").each(function (i, e) {
    $(e).trigger("click");
});

/* 
    Menu fixo mobile só aparece quando há a rolagem na página
*/

$(".sticky-finish-form.mobi-only").hide();

new MutationObserver(function () {
    if ($(".m-main-header").hasClass("is-mini") && window.innerWidth < 768)
        $(".sticky-finish-form.mobi-only").show();
    else
        $(".sticky-finish-form.mobi-only").hide();
}).observe($(".m-main-header")[0], { attributes: true, attributeFilter: ["class"] });

/*
    Após a sugestão, trás a página para a parte dos produtos
*/
window.onload = function () {
    if (location.href.match(/sugestao=1/)) {
        $("#prod_id")[0].scrollIntoView();
    }
}